import { Icon } from '@chakra-ui/react';

const CustomDesignGuideIcon = (props: any) => (
  <Icon viewBox="0 0 14 18" fill="none" {...props}>
    <defs>
      <linearGradient id="design-guide-stroke" x1="6.625" y1="0.625" x2="6.625" y2="16.625" gradientUnits="userSpaceOnUse">
        <stop offset="0.165" stopColor="#FF9554" />
        <stop offset="1" stopColor="#FF4935" />
      </linearGradient>
    </defs>
    <path
      d="M4.62585 14.6258C4.62585 14.0546 4.62585 13.7698 4.59465 13.5802C4.49705 12.9698 4.48025 12.9306 4.09065 12.4506C3.96905 12.301 3.52105 11.9003 2.62505 11.0971C1.71935 10.287 1.08096 9.22106 0.794324 8.04026C0.507692 6.85946 0.586336 5.61946 1.01985 4.48433C1.45336 3.34921 2.22131 2.37245 3.22209 1.68331C4.22286 0.994168 5.4093 0.625122 6.6244 0.625C7.8395 0.624879 9.02601 0.993688 10.0269 1.68263C11.0278 2.37157 11.796 3.34817 12.2297 4.48321C12.6635 5.61826 12.7424 6.85824 12.456 8.0391C12.1696 9.21995 11.5314 10.286 10.6258 11.0963C9.72905 11.8995 9.28105 12.301 9.16025 12.4498C8.77065 12.9298 8.75385 12.969 8.65545 13.5794C8.62505 13.769 8.62505 14.0546 8.62505 14.625H4.62505C4.62505 15.373 4.62505 15.7466 4.78585 16.025C4.89117 16.2074 5.04264 16.3589 5.22505 16.4642C5.50345 16.625 5.87705 16.625 6.62505 16.625C7.37305 16.625 7.74665 16.625 8.02585 16.465C8.20826 16.3597 8.35973 16.2082 8.46505 16.0258C8.62585 15.7474 8.62585 15.3738 8.62585 14.6258"
      stroke="url(#design-guide-stroke)"
      strokeWidth="1.25"
    />
    <path
      d="M6.6251 12.6265V11.0266M6.6251 11.0266C6.90595 11.0266 7.18184 10.9526 7.42507 10.8121C7.66829 10.6717 7.87027 10.4698 8.0107 10.2266M6.6251 11.0266C6.34426 11.0266 6.06836 10.9526 5.82514 10.8121C5.58191 10.6717 5.37994 10.4698 5.2395 10.2266"
      stroke="url(#design-guide-stroke)"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </Icon>
);

export default CustomDesignGuideIcon;
